<template lang="pug">
div
	b-modal(id="sfc-college-savings-questions-modal" size="sm" centered :hide-footer="true" :hide-header="true" ref="sfcCollegeSavingsQuestionsModal" @show="loadData(); trackModalShown()" @hide="redirect($event)" :no-close-on-backdrop="true" :no-close-on-esc="true")
		div
			b-row
				.close(@click="hideModal()" v-if="step != 'calculating'") CLOSE
				b-col
					h2 What is your state of residence?
					state-of-residence-question.state-of-residence-container
					//- div(v-if="step != 'calculating'")
					//- 	b-row
					//- 		b-col
					//- 			h3  {{ headerText }}
					//- 			sfc-progress-bar(:percent="progress")
					//- 			span.error(v-if="hasGeneralError")
					//- 				| An unexpected error has occurred. Please, try again.

					//- 	div(v-show="step == 'stateOfResidence'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques What is your state of residence?
					//- 		b-row
					//- 			b-col
					//- 				sfc-select-wrapper(:errorMessage="stateOfResidenceErrorMessage" :error="stateOfResidenceError")
					//- 					select(v-model="stateOfResidence" @change="validForm()" :class="{'empty':stateOfResidence == null}")
					//- 						option(:value="null" disabled="disabled") Select one
					//- 						option(v-for="state of states" :key="state.id" v-bind:value="state") {{state.name}}

					//- 	div(v-show="step == 'childAge'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques What is your child's age?
					//- 		b-row
					//- 			b-col
					//- 				sfc-select-wrapper(:errorMessage="childAgeErrorMessage" :error="childAgeError" style="max-width: 140px")
					//- 					select(v-model="childAge" @change="validForm()" :class="{'empty':childAge == null}")
					//- 						option(:value="null" disabled="disabled") Select one
					//- 						option(value="-1") future
					//- 						option(value="0") newborn
					//- 						option(value="1") 1 year old
					//- 						option(value="2") 2 years old
					//- 						option(value="3") 3 years old
					//- 						option(value="4") 4 years old
					//- 						option(value="5") 5 years old
					//- 						option(value="6") 6 years old
					//- 						option(value="7") 7 years old
					//- 						option(value="8") 8 years old
					//- 						option(value="9") 9 years old
					//- 						option(value="10") 10 years old
					//- 						option(value="11") 11 years old
					//- 						option(value="12") 12 years old
					//- 						option(value="13") 13 years old
					//- 						option(value="14") 14 years old
					//- 						option(value="15") 15 years old
					//- 						option(value="16") 16 years old
					//- 						option(value="17") 17 years old
					//- 						option(value="18") 18+ years old

					//- 	div(v-show="step == 'already529Plan'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques Do you already have a 529 plan?
					//- 		b-row
					//- 			b-col
					//- 				.radio-wrap
					//- 					.radio
					//- 						sfc-radio-input(v-model="hasA529Plan" :radio-value="true" label="Yes" @change="validForm()")
					//- 						sfc-radio-input(v-model="hasA529Plan" :radio-value="false" label="No" @change="validForm()")
					//- 					span.error(v-if="hasA529PlanError")
					//- 						| {{hasA529PlanErrorMessage}}

					//- 		b-row(v-if="hasA529Plan")
					//- 			b-col
					//- 				label.ques Are you planning to open a new 529 plan?
					//- 		b-row(v-if="hasA529Plan")
					//- 			b-col
					//- 				.radio-wrap
					//- 						.radio
					//- 							sfc-radio-input(v-model="isPlanningToOpenANew529" :radio-value="true" label="Yes" @change="validForm()")
					//- 							sfc-radio-input(v-model="isPlanningToOpenANew529" :radio-value="false" label="No" @change="validForm()")
					//- 						span.error(v-if="isPlanningToOpenANew529Error")
					//- 							| {{isPlanningToOpenANew529ErrorMessage}}

					//- 	div(v-show="step == 'taxFilingStatus'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques
					//- 					| Help us better personalize our advice to your specific situation.
					//- 					br
					//- 					br
					//- 					| What is your tax filing status? We use your answer to find and calculate potential tax benefits.
					//- 		b-row
					//- 			b-col
					//- 				sfc-select-wrapper(:errorMessage="taxFilingStatusIdErrorMessage" :error="taxFilingStatusIdError" style="max-width: 210px")
					//- 					select(v-model="taxFilingStatusId"  @change="validForm()" :class="{'empty':taxFilingStatusId == null}")
					//- 						option(:value="null" disabled="disabled") Select one
					//- 						option(v-for="taxFilingStatus of taxFilingStatuses" :key="taxFilingStatus.id" :value="taxFilingStatus.id" :show_disabled_option="true") {{taxFilingStatus.name}}
					//- 		// b-row
					//- 			b-col
					//- 				p.disclaimer This allows us to calculate your potential tax benefits with a 529 plan.

					//- 	div(v-show="step == 'householdIncome'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques What is your current yearly household income? We use your answer to project future costs of college and calculate and potential state tax benefits.
					//- 		b-row
					//- 			b-col
					//- 				sfc-input(v-model="householdIncome" @input="validForm()" type="money" :class="{'empty':householdIncome == 0}" :error="householdIncomeError" :error-message="householdIncomeErrorMessage" style="max-width: 100px")
					//- 				span &nbsp; per year
					//- 		// b-row
					//- 			b-col
					//- 				p.disclaimer This allows us to calculate your potential tax benefits with a 529 plan.

					//- 	div(v-show="step == 'monthlyContribution'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques Given your current expenses, how much can you reasonably afford to save for college on a monthly basis?
					//- 		b-row
					//- 			b-col
					//- 				sfc-input(v-model="monthlyContribution" @input="validForm()" type="money"  :class="{'empty':monthlyContribution == 0}" :error="monthlyContributionError" :error-message="monthlyContributionErrorMessage" style="max-width: 100px")
					//- 				span &nbsp;per month

					//- 	div(v-show="step == 'moreImportant'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques Which of these is most important to you in selecting a 529 plan?
					//- 		b-row
					//- 			b-col
					//- 				span.error(v-if="moreImportantError")
					//- 					| {{moreImportantErrorMessage}}
					//- 		b-row
					//- 			b-col
					//- 				div
					//- 					sfc-checkbox(cb-label="High ratings" v-model="highlyRated" @change="validForm()")
					//- 				div
					//- 					sfc-checkbox(cb-label="Low fees" v-model="lowFees" @change="validForm()")
					//- 				div
					//- 					sfc-checkbox(cb-label="Strong performance" v-model="bestPerforming" @change="validForm()")
					//- 				div
					//- 					sfc-checkbox(cb-label="High maximum contributions" v-model="highMaximums" @change="validForm()")

					//- 	div(v-show="step == 'email'")
					//- 		b-row
					//- 			b-col
					//- 				label.ques Recommended:
					//- 					br
					//- 					| Don't miss out. Get college savings advice and pro tips straight to your inbox.
					//- 		b-row
					//- 			b-col
					//- 				sfc-input(v-model="email" placeholder="Your email" @input="validForm()" type="text" :class="{'empty':email == ''}" :error="emailError" :error-message="emailErrorMessage" style="max-width: 350px")
					//- 		// b-row
					//- 			b-col
					//- 				p.disclaimer *Don't worry, we hate spam as much as you do. We won't sell or share your email address, we'll only use it to send you information you may be interested in as a college saver.

					//- div.calculation-step(v-show="step == 'calculating'")
					//- 	b-row
					//- 		b-col(cols="10")
					//- 			div
					//- 				p Analyzing your answers
					//- 				sfc-progress-bar(:percent="analyzingPercentage")
					//- 		b-col(cols="2")
					//- 			.completion-check-circle(:class="{'complete': analyzingPercentage >= 100 }")
					//- 				.checkmark
					//- 	b-row
					//- 		b-col(cols="10")
					//- 			div
					//- 				p Personalizing content for you
					//- 				sfc-progress-bar(:percent="personalizingPercentage")
					//- 		b-col(cols="2")
					//- 			.completion-check-circle(:class="{'complete': personalizingPercentage >= 100 }")
					//- 				.checkmark
					//- 	b-row
					//- 		b-col(cols="10")
					//- 			div
					//- 				p Finding college savings plans for you
					//- 				sfc-progress-bar(:percent="findingPercentage")
					//- 		b-col(cols="2")
					//- 			.completion-check-circle(:class="{'complete': findingPercentage >= 100 }")
					//- 				.checkmark

						//span.spinner(v-if="loading && findingPercentage >= 100")
							spinner(size="20")

			//- div.modal-footer(slot="modal-footer" v-if="step != 'calculating'")
			//- 	a.btn.prev(@click="previous()" v-if="!isFirstStep")
			//- 		span.arrow-left
			//- 	a.btn.sfc-blue.next(@click="next()")
			//- 		span NEXT
			//- 		span.arrow-right

</template>

<style lang="stylus">
@import '~assets/css/variables.styl'

	a.btn
		&.prev
			padding-left: 20px!important
			padding-right: 20px!important
			&:hover
				border: 1px solid #444



		&.prev
		&.next
			> span
				position: relative
				display: inline-block
				&.arrow-right
					border-left: 6px solid #fff
					right: -15px
				&.arrow-left
					border-right: 6px solid #444


#sfc-college-savings-questions-modal-loader
#sfc-college-savings-questions-modal
	z-index: 5001
	& + .modal-backdrop
		z-index: 5000

	.tb
		display: inline-block
		vertical-align: middle
		&.empty
			input
				color: #e3eaf3
		+ span
			display: inline-block
			vertical-align: middle
			color: #657486

	label.ques
		margin-top: 30px
	.cb-cont
	label.ques
		padding-top: 10px
	.radio
		margin-bottom: 30px
	.tb
		max-width: 250px
		span.arrow-down
			right: 0
			//- top: 55%
			//- top: calc(50% - 3.5px)
			z-index: 15
		&:hover
			span.arrow-down
				border-top: 7px solid #000
	span.error
		color: chart-red
	.modal-dialog
		max-width: 435px!important
	// .modal-body
	// 	> div
	// 		padding-bottom: 100px
	// 		//- position: relative

</style>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#sfc-college-savings-questions-modal
		position: relative
		.calculation-step
			margin-top: 60px
			p
				font-size: body-font-size-lg
				margin-bottom: 10px
				@media (max-width: 567px)
					font-size: body-font-size-md
		.completion-check-circle
			border-radius(50%)
			border: 1px solid sfc-pale-gray
			height: 30px
			width: 30px
			position: relative
			top: 31px
			transition-all-four()
			&.complete
				border: 1px solid sfc-blue-border
				background: sfc-blue
			.checkmark
				border-color: #fff
				position: relative
				left: 8px
				bottom: 0px
		h3
			font-size: body-font-size-lg-plus
		.close
			text-shadow: none
			position: absolute
			top: -20px
			font-size: body-font-size-md
			color: #fff
			opacity: 0.7
			transition-all()
			right: 0
			font-weight: body-font-weight
			cursor: pointer
			&:hover
				opacity: 1
		.row
			margin: 15px 0
			@media (max-width: 576px)
				margin: 15px -15px
			.radio-wrap
				margin-top: 10px

		.modal-footer
			background: #fff
			position: absolute
			border: none!important
			bottom: 0
			width: 100%
			left: 0
			border-bottom-radius()
			height: 95px
			padding: 0px 45px
			justify-content: flex-start
			a.btn
				padding-left: 45px
				padding-right: 45px
				margin-left: 15px
			@media screen and (max-width: 576px)
				padding: 0px 15px
				a.btn
					margin: 15px
					width: 50%
					max-width: 250px
		.modal-dialog
			text-align: left
			.tb
				margin: 0
				label
					margin-bottom: 15px

					input
						&::placeholder
							color: #fff
							opacity: 1
						&:focus
							&::placeholder
								color: #fff
								opacity: 0
							+ span.floaty-label
								top: 20px!important
					.floaty-label
						top: 40px
					&.not-empty
						.floaty-label
							opacity: 1
							top: 20px!important
				&.tbs
					.floaty-label
						top: 5px
						// display: none
						opacity: 0
						transition-all()
						font-size: body-font-size-xs
						&.show-floaty
							opacity: 1
				// select
				// 	margin: 0
				// 	margin-bottom: 0
				// 	&:focus
				// 		color: sfc-blue
				input
					margin: 30px 0
					margin-bottom: 0px
					&:focus
						color: sfc-blue

		.state-of-residence-container
			>>> .dd
				margin-top: 20px
				margin-bottom: 40px

	.disclaimer
		font-size: body-font-size-sm;
		font-style: italic;

</style>

<script>
import SfcTrackingService from "@/lib/sfc-tracking-service"
import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'
import stateOfResidenceQuestion from '@/pages/savings-center/onboarding/questions/state-of-residence.vue'

export default {
	data() {
		return {
			taxFilingStatusId: null,
			taxFilingStatusIdError: false,
			taxFilingStatusIdErrorMessage: "",
			householdIncome: "",
			householdIncomeError: false,
			householdIncomeErrorMessage: "",
			childAge: null,
			childAgeError: false,
			childAgeErrorMessage: "",
			monthlyContribution: "",
			monthlyContributionError: false,
			monthlyContributionErrorMessage: "",
			stateOfResidence: null,
			stateOfResidenceError: false,
			stateOfResidenceErrorMessage: "",
			hasA529Plan: null,
			hasA529PlanError: false,
			hasA529PlanErrorMessage: "",
			isPlanningToOpenANew529: null,
			isPlanningToOpenANew529Error: false,
			isPlanningToOpenANew529ErrorMessage: "",
			stateFromIp: null,
			moreImportant: null,
			moreImportantError: false,
			moreImportantErrorMessage: "",
			email: "",
			emailError: false,
			emailErrorMessage: "",
			highlyRated: false,
			lowFees: false,
			bestPerforming: false,
			highMaximums: false,
			validateOnChange: false,
			ready: true,
			loading: false,
			taxFilingStatuses: [],
			states: [],
			userFloaty: false,
			stateFloaty: false,
			emailFloaty: false,
			showAllFields: true,
			timeoutPromise: null,
			preventBackIfPhp: false,
			hasGeneralError: false,
			step: 'stateOfResidence',
			analyzingPercentage: 0,
			personalizingPercentage: 0,
			findingPercentage: 0,
			originallyComingFrom: ""

		}
	},

	async created() {
		this.taxFilingStatuses = await this.$store.dispatch('getGeneralDataJson')
		this.stateFromIp = this.$store.state.stateFromIp
		this.states = [
			{
				"id": "AL",
				"name": "Alabama",
				"slug": "alabama",
				"sfc_id": 1
			},
			{
				"id": "AK",
				"name": "Alaska",
				"slug": "alaska",
				"sfc_id": 2
			},
			{
				"id": "AZ",
				"name": "Arizona",
				"slug": "arizona",
				"sfc_id": 3
			},
			{
				"id": "AR",
				"name": "Arkansas",
				"slug": "arkansas",
				"sfc_id": 4
			},
			{
				"id": "CA",
				"name": "California",
				"slug": "california",
				"sfc_id": 5
			},
			{
				"id": "CO",
				"name": "Colorado",
				"slug": "colorado",
				"sfc_id": 6
			},
			{
				"id": "CT",
				"name": "Connecticut",
				"slug": "connecticut",
				"sfc_id": 7
			},
			{
				"id": "DE",
				"name": "Delaware",
				"slug": "delaware",
				"sfc_id": 8
			},
			{
				"id": "DC",
				"name": "District of Columbia",
				"slug": "district-of-columbia",
				"sfc_id": 9
			},
			{
				"id": "FL",
				"name": "Florida",
				"slug": "florida",
				"sfc_id": 10
			},
			{
				"id": "GA",
				"name": "Georgia",
				"slug": "georgia",
				"sfc_id": 11
			},
			{
				"id": "HI",
				"name": "Hawaii",
				"slug": "hawaii",
				"sfc_id": 12
			},
			{
				"id": "ID",
				"name": "Idaho",
				"slug": "idaho",
				"sfc_id": 13
			},
			{
				"id": "IL",
				"name": "Illinois",
				"slug": "illinois",
				"sfc_id": 14
			},
			{
				"id": "IN",
				"name": "Indiana",
				"slug": "indiana",
				"sfc_id": 15
			},
			{
				"id": "IA",
				"name": "Iowa",
				"slug": "iowa",
				"sfc_id": 16
			},
			{
				"id": "KS",
				"name": "Kansas",
				"slug": "kansas",
				"sfc_id": 17
			},
			{
				"id": "KY",
				"name": "Kentucky",
				"slug": "kentucky",
				"sfc_id": 18
			},
			{
				"id": "LA",
				"name": "Louisiana",
				"slug": "louisiana",
				"sfc_id": 19
			},
			{
				"id": "ME",
				"name": "Maine",
				"slug": "maine",
				"sfc_id": 20
			},
			{
				"id": "MD",
				"name": "Maryland",
				"slug": "maryland",
				"sfc_id": 21
			},
			{
				"id": "MA",
				"name": "Massachusetts",
				"slug": "massachusetts",
				"sfc_id": 22
			},
			{
				"id": "MI",
				"name": "Michigan",
				"slug": "michigan",
				"sfc_id": 23
			},
			{
				"id": "MN",
				"name": "Minnesota",
				"slug": "minnesota",
				"sfc_id": 24
			},
			{
				"id": "MS",
				"name": "Mississippi",
				"slug": "mississippi",
				"sfc_id": 25
			},
			{
				"id": "MO",
				"name": "Missouri",
				"slug": "missouri",
				"sfc_id": 26
			},
			{
				"id": "MT",
				"name": "Montana",
				"slug": "montana",
				"sfc_id": 27
			},
			{
				"id": "NE",
				"name": "Nebraska",
				"slug": "nebraska",
				"sfc_id": 28
			},
			{
				"id": "NV",
				"name": "Nevada",
				"slug": "nevada",
				"sfc_id": 29
			},
			{
				"id": "NH",
				"name": "New Hampshire",
				"slug": "new-hampshire",
				"sfc_id": 30
			},
			{
				"id": "NJ",
				"name": "New Jersey",
				"slug": "new-jersey",
				"sfc_id": 31
			},
			{
				"id": "NM",
				"name": "New Mexico",
				"slug": "new-mexico",
				"sfc_id": 32
			},
			{
				"id": "NY",
				"name": "New York",
				"slug": "new-york",
				"sfc_id": 33
			},
			{
				"id": "NC",
				"name": "North Carolina",
				"slug": "north-carolina",
				"sfc_id": 34
			},
			{
				"id": "ND",
				"name": "North Dakota",
				"slug": "north-dakota",
				"sfc_id": 35
			},
			{
				"id": "OH",
				"name": "Ohio",
				"slug": "ohio",
				"sfc_id": 36
			},
			{
				"id": "OK",
				"name": "Oklahoma",
				"slug": "oklahoma",
				"sfc_id": 37
			},
			{
				"id": "OR",
				"name": "Oregon",
				"slug": "oregon",
				"sfc_id": 38
			},
			{
				"id": "OTHER",
				"name": "Other",
				"slug": "other",
				"sfc_id": 99
			},
			{
				"id": "PA",
				"name": "Pennsylvania",
				"slug": "pennsylvania",
				"sfc_id": 39
			},
			{
				"id": "RI",
				"name": "Rhode Island",
				"slug": "rhode-island",
				"sfc_id": 40
			},
			{
				"id": "SC",
				"name": "South Carolina",
				"slug": "south-carolina",
				"sfc_id": 41
			},
			{
				"id": "SD",
				"name": "South Dakota",
				"slug": "south-dakota",
				"sfc_id": 42
			},
			{
				"id": "TN",
				"name": "Tennessee",
				"slug": "tennessee",
				"sfc_id": 43
			},
			{
				"id": "TX",
				"name": "Texas",
				"slug": "texas",
				"sfc_id": 44
			},
			{
				"id": "UT",
				"name": "Utah",
				"slug": "utah",
				"sfc_id": 45
			},
			{
				"id": "VT",
				"name": "Vermont",
				"slug": "vermont",
				"sfc_id": 46
			},
			{
				"id": "VA",
				"name": "Virginia",
				"slug": "virginia",
				"sfc_id": 47
			},
			{
				"id": "WA",
				"name": "Washington",
				"slug": "washington",
				"sfc_id": 48
			},
			{
				"id": "WV",
				"name": "West Virginia",
				"slug": "west-virginia",
				"sfc_id": 49
			},
			{
				"id": "WI",
				"name": "Wisconsin",
				"slug": "wisconsin",
				"sfc_id": 50
			},
			{
				"id": "WY",
				"name": "Wyoming",
				"slug": "wyoming",
				"sfc_id": 51
			}
		]
	},

	props: [],
	components:{
		Spinner,
		stateOfResidenceQuestion
	},
	computed: {
		buttonText(){
			if(this.$store.state.toCollegeSavingsModalComingFrom == "dashboard"){
				return "Update"
			}
			return "Next"
		},
		headerText(){
			if(this.$store.state.toCollegeSavingsModalComingFrom == "dashboard"){
				return "Edit your responses"
			}
			return "Get personalized information"
		},
		isFirstStep(){
			if(this.originallyComingFrom == "homepage" && this.step == 'taxFilingStatus')
				return true
			if(this.step == 'stateOfResidence')
				return true
			return false
		},
		progress(){
			let progress = 0
			if(this.step == "stateOfResidence")
				progress = 0
			if(this.step == "childAge")
				progress = 15
			if(this.step == "already529Plan")
				progress = 30
			if(this.step == "taxFilingStatus")
				progress = 45
			if(this.step == "householdIncome")
				progress = 60
			if(this.step == "monthlyContribution")
				progress = 75
			if(this.step == "moreImportant")
				progress = 85
			if(this.step == "email")
				progress = 95

			if(this.originallyComingFrom == "homepage"){
				if(this.step == "taxFilingStatus")
					progress = 0
				if(this.step == "householdIncome")
					progress = 25
				if(this.step == "monthlyContribution")
					progress = 50
				if(this.step == "moreImportant")
					progress = 75
				if(this.step == "email")
					progress = 95
			}
			return progress
		}
	},
	methods: {
		async loadData() {
			this.step = 'stateOfResidence'
			this.$store.commit('updateClosePathModal', false)
			this.cleanModal(true)



			this.originallyComingFrom = this.$store.state.toCollegeSavingsModalComingFrom
			if (this.$store.state.toCollegeSavingsModalComingFrom == "homepage") {
				this.step = 'taxFilingStatus'
				this.trackStep('taxFilingStatus', 'shown')
				this.$store.commit('updateToCollegeSavingsModalComingFrom', "")
				this.showAllFields = false
				this.stateOfResidence = this.$store.state.stateOfResidence || this.stateFromIp
				if (this.$store.state.hasA529Plan != null) {
					this.hasA529Plan = this.$store.state.hasA529Plan
				}
				if (this.$store.state.childAge != null) {
					this.childAge = this.$store.state.childAge
				}
			}else{
				this.trackStep('stateOfResidence', 'shown')
				this.showAllFields = true
				if(this.$store.state.savingsUser){
					this.stateOfResidence = this.$store.state.savingsUser.state
					this.hasA529Plan = this.$store.state.savingsUser.has_a_529_plan
					this.isPlanningToOpenANew529 = this.$store.state.savingsUser.is_planning_to_open_a_new_529
					this.taxFilingStatusId = this.$store.state.savingsUser.tax_filing_status_id
					this.householdIncome = this.$store.state.savingsUser.household_income
					this.childAge = this.$store.state.savingsUser.child_age
					this.monthlyContribution = this.$store.state.savingsUser.monthly_contribution
					this.lowFees = this.$store.state.savingsUser.low_fees
					this.bestPerforming = this.$store.state.savingsUser.best_performing
					this.highMaximums = this.$store.state.savingsUser.high_maximums
					this.highlyRated = this.$store.state.savingsUser.highly_rated
					this.moreImportant = this.$store.state.savingsUser.more_important
					this.email = this.$store.state.savingsUser.email
				}
			}
		},
		trackModalShown(){
			this.trackAction("Savings Center", "Modal", "Shown")
		},
		redirect(event){
			if(this.$route.path == '/savings-center/take-action/find-best-plans'){
				event.preventDefault()
			}
		},
		hideModal() {
			if(this.$route.path != '/savings-center/take-action/find-best-plans' || this.preventBackIfPhp){
				this.$refs.sfcCollegeSavingsQuestionsModal.hide()
				this.loading = false
				setTimeout(()=>{
					this.cleanModal()
				},0)
			}else{
				window.history.back()
			}
		},



		validForm() {
			if (this.validateOnChange) {
				this.clearErrors()

				if(this.step == "stateOfResidence"){
					if (!this.stateOfResidence || this.stateOfResidence == "") {
						this.stateOfResidenceError = true
						this.stateOfResidenceErrorMessage = "Required"
					}
				}

				if(this.step == "childAge"){
					if (this.childAge == null || this.childAge == undefined || this.childAge === "") {
						this.childAgeError = true
						this.childAgeErrorMessage = "Required"
					}
				}

				if(this.step == "already529Plan"){
					if (this.hasA529Plan == null) {
						this.hasA529PlanError = true
						this.hasA529PlanErrorMessage = "Required"
					}

					if (this.hasA529Plan && this.isPlanningToOpenANew529 == null) {
						this.isPlanningToOpenANew529Error = true
						this.isPlanningToOpenANew529ErrorMessage = "Required"
					}
				}

				if(this.step == "taxFilingStatus"){
					if (!this.taxFilingStatusId || this.taxFilingStatusId == "") {
						this.taxFilingStatusIdError = true
						this.taxFilingStatusIdErrorMessage = "Required"
					}
				}

				if(this.step == "householdIncome"){
					if (!this.householdIncome || this.householdIncome == "" || this.householdIncome == 0) {
						this.householdIncomeError = true
						this.householdIncomeErrorMessage = "Required"
					}
				}


				if(this.step == "monthlyContribution"){
					if (!this.monthlyContribution || this.monthlyContribution == "" || this.monthlyContribution == 0) {
						this.monthlyContributionError = true
						this.monthlyContributionErrorMessage = "Required"
					}
				}

				if(this.step == "moreImportant"){
					if (!this.highlyRated && !this.lowFees && !this.bestPerforming && !this.highMaximums) {
						this.moreImportantError = true
						this.moreImportantErrorMessage = "Required"
					}
				}

				if(this.step == "email"){
					if (this.email && this.email != "") {
						const emailRegex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						if (!emailRegex.test(this.email)) {
							this.emailError = true
							this.emailErrorMessage = "Please enter a valid email"
						}


					}
				}

			}

			return !this.taxFilingStatusIdError && !this.stateOfResidenceError && !this.householdIncomeError && !this.childAgeError && !this.monthlyContributionError && !this.hasA529PlanError && !this.isPlanningToOpenANew529Error && !this.moreImportantError && !this.emailError

		},

		next(){
			this.validateOnChange = true
			if (this.validForm()) {
				this.validateOnChange = false

				if(this.step == "stateOfResidence"){
					this.step = "childAge"
					this.trackStep("stateOfResidence", "submitted")
					this.trackStep("childAge", "shown")
					return
				}

				if(this.step == "childAge"){
					this.step = "already529Plan"
					this.trackStep("childAge", "submitted")
					this.trackStep("already529Plan", "shown")
					return
				}

				if(this.step == "already529Plan"){
					this.step = "taxFilingStatus"
					this.trackStep("already529Plan", "submitted")
					this.trackStep("taxFilingStatus", "shown")
					return
				}

				if(this.step == "taxFilingStatus"){
					let action = "tax filing status"
					if(this.originallyComingFrom == "homepage")
						action = "tax filing status - start"
					this.step = "householdIncome"
					this.trackStep("taxFilingStatus", "submitted")
					this.trackStep("householdIncome", "shown")
					return
				}

				if(this.step == "householdIncome"){
					this.step = "monthlyContribution"
					this.trackStep("householdIncome", "submitted")
					this.trackStep("monthlyContribution", "shown")
					return
				}

				if(this.step == "monthlyContribution"){
					this.step = "moreImportant"
					this.trackStep("monthlyContribution", "submitted")
					this.trackStep("moreImportant", "shown")
					return
				}

				if(this.step == "moreImportant"){
					this.trackStep("moreImportant", "submitted")
					if(this.$store.state.userIsLoggedIn){
						this.step = "calculating"
						this.analyzingPercentage = 0
						this.personalizingPercentage = 0
						this.findingPercentage = 0
						this.startLoader()
						this.submitV2()
					}else{
						this.step = "email"
						this.trackStep("email", "shown")
					}
					return
				}

				if(this.step == "email"){
					this.step = "calculating"
					if (this.email && this.email != ""){
						this.trackStep("email", "submitted")
					}
					this.analyzingPercentage = 0
					this.personalizingPercentage = 0
					this.findingPercentage = 0
					this.startLoader()
					this.submitV2()
					return
				}


			}
		},

		previous(){
			this.validateOnChange = false
			if(this.step == "childAge"){
				this.step = "stateOfResidence"
				return
			}

			if(this.step == "already529Plan"){
				this.step = "childAge"
				return
			}

			if(this.step == "taxFilingStatus"){
				this.step = "already529Plan"
				return
			}

			if(this.step == "householdIncome"){
				this.step = "taxFilingStatus"
				return
			}

			if(this.step == "monthlyContribution"){
				this.step = "householdIncome"
				return
			}

			if(this.step == "moreImportant"){
				this.step = "monthlyContribution"
				return
			}

			if(this.step == "email"){
				this.step = "moreImportant"
				return
			}

		},

		trackStep(step, action){
			this.trackAction("Savings Center", "Modal", `${step} - ${action}`)
		},


		async submitV2() {
			this.hasGeneralError = false
			if(!this.hasA529Plan){
				this.isPlanningToOpenANew529 = null
			}
			this.loading = true
			const query = `
				mutation{
					college_savings_user(sfc_token: "${this.$cookies.get('sfc_primary')}", token:"${this.$cookies.get('college_savings_token')}", household_income: ${this.householdIncome}, child_age: ${this.childAge}, monthly_contribution: ${this.monthlyContribution}, tax_filing_status_id: ${this.taxFilingStatusId}, has_a_529_plan: ${!!this.hasA529Plan}, is_planning_to_open_a_new_529: ${this.isPlanningToOpenANew529} ,highly_rated: ${!!this.highlyRated}, low_fees: ${!!this.lowFees}, best_performing: ${!!this.bestPerforming}, high_maximums: ${!!this.highMaximums}, more_important: "${this.moreImportant}", state_id: ${this.stateOfResidence.id}, email: "${this.email || ''}"){
						token
						household_income
						child_age
						quiz_completed
						monthly_contribution
						tax_filing_status_id
						has_a_529_plan
						is_planning_to_open_a_new_529
						highly_rated
						low_fees
						best_performing
						high_maximums
						more_important
						bank_of_america
						email
						state{
							id
							name
							slug
							sfc_id
							number_of_plans
						}
						state_plan{
							id
							state_id
							name
							state_abbreviation
							overall_rating
							plan_details_url
							logo_url
							state_object{
								id
								name
							}
							state_residency_requirements
							has_enroll_now
							enroll_now_url
							enroll_now_count
							rating_designation
							fees_five_star_score
							performance_five_star_score
							one_year_performance_five_star_score
							three_year_performance_five_star_score
							five_year_performance_five_star_score
							ten_year_performance_five_star_score
						}
					}
				}
			`
			try {
				const response = await this.$httpService.graphql(query)
				let token = response.data.college_savings_user.token
				this.$cookies.set('college_savings_token', token, {
					path: '/',
					domain: 'savingforcollege.com',
					maxAge: 365 * 24 * 60 * 60
				})


				this.$store.commit("updateSavingsUser", response.data.college_savings_user)
				this.loading = false
				this.trackAction("Savings Center", "Modal", "Submit")
				if (this.$route.path != "/savings-center/plan/college-savings-calculator") {
					this.activeWaitToCloseModal(false)
				}else{
					this.activeWaitToCloseModal(true)
				}
			} catch (e) {
				this.hasGeneralError = true
			}
		},

		activeWaitToCloseModal(closeImmediatlyAfterLoader){
			this.preventBackIfPhp = true
			if(this.findingPercentage >= 100){
				clearTimeout(this.timeoutPromise);
				this.$store.commit('updateClosePathModal', false)
				if(this.$route.path != "/savings-center/plan/college-savings-calculator"){
					window.location.href = '/savings-center/plan/college-savings-calculator'
				}else{
					this.hideModal()
				}
			}else{
				this.timeoutPromise = setTimeout(()=>{
					this.activeWaitToCloseModal(closeImmediatlyAfterLoader)
				}, 300)
			}
		},

		startLoader(){
			if(this.findingPercentage >= 100){
				return
			}

			if(this.analyzingPercentage < 100){
				this.analyzingPercentage+=10
			} else if(this.personalizingPercentage < 100){
				this.personalizingPercentage+=6
			} else if(this.findingPercentage < 100){
				if(this.findingPercentage > 90 && this.loading){
					// Keep waiting
				}else{
					this.findingPercentage+=14
				}
			}

			setTimeout(() => {
				this.startLoader()
			}, 100 )

		},

		cleanModal(immediatly = false){
			if(immediatly){
				this.clearValues()
			}else{
				setTimeout( () => {
					this.clearValues()
				}, 1000 )
			}
		},

		clearValues(){
			this.taxFilingStatusId = null
			this.householdIncome = ""
			this.childAge = null
			this.monthlyContribution = ""
			this.hasA529Plan = null
			this.isPlanningToOpenANew529 = null
			this.lowFees = false
			this.bestPerforming = false
			this.highMaximums = false
			this.highlyRated = false
			this.validateOnChange = false
			this.clearErrors()
		},

		clearErrors(){
			this.taxFilingStatusIdError = false
			this.taxFilingStatusIdErrorMessage = ""
			this.householdIncomeError = false
			this.householdIncomeErrorMessage = ""
			this.childAgeError = false
			this.childAgeErrorMessage = ""
			this.monthlyContributionError = false
			this.monthlyContributionErrorMessage = ""
			this.stateOfResidenceError = false
			this.stateOfResidenceErrorMessage = ""
			this.hasA529PlanError = false
			this.hasA529PlanErrorMessage = ""
			this.isPlanningToOpenANew529Error = false
			this.isPlanningToOpenANew529ErrorMessage = ""
			this.moreImportantError = false
			this.moreImportantErrorMessage = ""
			this.emailError = false
			this.emailMessage = ""
		},

		trackAction(eventCategory, eventAction, eventLabel, additionalInformation = false) {
			SfcTrackingService.trackAction(eventCategory, eventAction, eventLabel, additionalInformation)
		}
	}
}
</script>
